<template>
  <span class="svg-ico-cpd-content">
    <svg
      v-if="isTwoTone"
      :style="`width:${width}px;height:${width}px;fill:none;`"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.66 8.3115C10.06 8.3115 10.38 8.6015 10.44 8.9915V14.3215C10.44 14.7515 10.09 15.1015 9.66 15.1015C9.26 15.1015 8.94 14.8115 8.88 14.4215V9.0915C8.88 8.6615 9.23 8.3115 9.66 8.3115Z"
        :fill="color"
      />
      <path
        d="M11.93 8.3115C13.24 8.3115 14.3 9.3715 14.3 10.6815C14.3 11.9915 13.32 12.9615 12.09 13.0515H9.66C9.23 13.0515 8.88 12.7015 8.88 12.2715C8.88 11.8715 9.17 11.5515 9.56 11.4915H11.94C12.38 11.4915 12.75 11.1315 12.75 10.6815C12.75 10.2715 12.45 9.9315 12.05 9.8815H9.67C9.24 9.8815 8.89 9.5315 8.89 9.1015C8.89 8.7015 9.18 8.3815 9.57 8.3215H11.95L11.93 8.3115Z"
        :fill="color"
      />
      <path
        d="M17.63 8.3115C19.21 8.3115 20.5 9.5915 20.5 11.1815V12.2215C20.5 12.9815 20.2 13.7115 19.66 14.2515C19.12 14.7915 18.39 15.0915 17.63 15.0915H16.06C15.63 15.0915 15.28 14.7415 15.28 14.3115V9.0915C15.28 8.6615 15.63 8.3115 16.06 8.3115H17.63ZM16.85 9.8715V13.5215H17.63C17.98 13.5215 18.31 13.3815 18.55 13.1415C18.79 12.9015 18.93 12.5615 18.93 12.2215V11.1815C18.93 10.4615 18.35 9.8815 17.63 9.8815H16.85V9.8715Z"
        :fill="color"
      />
      <path
        d="M7 8.3115C7.43 8.3115 7.78 8.6615 7.78 9.0915C7.78 9.5215 7.43 9.8715 7 9.8715H5.33C5.19 9.8715 5.07 9.9915 5.07 10.1315V13.2615C5.07 13.4015 5.19 13.5215 5.33 13.5215H7C7.43 13.5215 7.78 13.8715 7.78 14.3015C7.78 14.7315 7.43 15.0815 7 15.0815H5.33C4.32 15.0815 3.5 14.2615 3.5 13.2515V10.1215C3.5 9.1115 4.32 8.2915 5.33 8.2915H7V8.3115Z"
        :fill="color"
      />
      <path
        d="M4.79942 7.05117H19.1994C19.4794 7.05117 19.7394 6.89117 19.8694 6.64117C19.9994 6.39117 19.9694 6.09117 19.8094 5.86117C18.0294 3.41117 15.1094 1.95117 11.9994 1.95117C8.88942 1.95117 5.96942 3.41117 4.18942 5.86117C4.01942 6.09117 3.99942 6.39117 4.12942 6.64117C4.25942 6.89117 4.51942 7.05117 4.79942 7.05117Z"
        :fill="color2"
      />
      <path
        d="M19.1994 16.3512H4.79942C4.51942 16.3512 4.25942 16.5112 4.12942 16.7612C3.99942 17.0112 4.02942 17.3112 4.18942 17.5412C5.96942 19.9912 8.88942 21.4512 11.9994 21.4512C15.1094 21.4512 18.0294 19.9912 19.8094 17.5412C19.9794 17.3112 19.9994 17.0112 19.8694 16.7612C19.7394 16.5112 19.4794 16.3512 19.1994 16.3512Z"
        :fill="color2"
      />
    </svg>
    <svg
      v-else-if="isSolid"
      :style="`width:${width}px;height:${width}px;fill:none;`"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.66 8.3115C10.06 8.3115 10.38 8.6015 10.44 8.9915V14.3215C10.44 14.7515 10.09 15.1015 9.66 15.1015C9.26 15.1015 8.94 14.8115 8.88 14.4215V9.0915C8.88 8.6615 9.23 8.3115 9.66 8.3115Z"
        :fill="color"
      />
      <path
        d="M11.93 8.3115C13.24 8.3115 14.3 9.3715 14.3 10.6815C14.3 11.9915 13.32 12.9615 12.09 13.0515H9.66C9.23 13.0515 8.88 12.7015 8.88 12.2715C8.88 11.8715 9.17 11.5515 9.56 11.4915H11.94C12.38 11.4915 12.75 11.1315 12.75 10.6815C12.75 10.2715 12.45 9.9315 12.05 9.8815H9.67C9.24 9.8815 8.89 9.5315 8.89 9.1015C8.89 8.7015 9.18 8.3815 9.57 8.3215H11.95L11.93 8.3115Z"
        :fill="color"
      />
      <path
        d="M17.63 8.3115C19.21 8.3115 20.5 9.5915 20.5 11.1815V12.2215C20.5 12.9815 20.2 13.7115 19.66 14.2515C19.12 14.7915 18.39 15.0915 17.63 15.0915H16.06C15.63 15.0915 15.28 14.7415 15.28 14.3115V9.0915C15.28 8.6615 15.63 8.3115 16.06 8.3115H17.63ZM16.85 9.8715V13.5215H17.63C17.98 13.5215 18.31 13.3815 18.55 13.1415C18.79 12.9015 18.93 12.5615 18.93 12.2215V11.1815C18.93 10.4615 18.35 9.8815 17.63 9.8815H16.85V9.8715Z"
        :fill="color"
      />
      <path
        d="M7 8.3115C7.43 8.3115 7.78 8.6615 7.78 9.0915C7.78 9.5215 7.43 9.8715 7 9.8715H5.33C5.19 9.8715 5.07 9.9915 5.07 10.1315V13.2615C5.07 13.4015 5.19 13.5215 5.33 13.5215H7C7.43 13.5215 7.78 13.8715 7.78 14.3015C7.78 14.7315 7.43 15.0815 7 15.0815H5.33C4.32 15.0815 3.5 14.2615 3.5 13.2515V10.1215C3.5 9.1115 4.32 8.2915 5.33 8.2915H7V8.3115Z"
        :fill="color"
      />
      <path
        d="M4.79942 7.05117H19.1994C19.4794 7.05117 19.7394 6.89117 19.8694 6.64117C19.9994 6.39117 19.9694 6.09117 19.8094 5.86117C18.0294 3.41117 15.1094 1.95117 11.9994 1.95117C8.88942 1.95117 5.96942 3.41117 4.18942 5.86117C4.01942 6.09117 3.99942 6.39117 4.12942 6.64117C4.25942 6.89117 4.51942 7.05117 4.79942 7.05117Z"
        :fill="color"
      />
      <path
        d="M19.1994 16.3512H4.79942C4.51942 16.3512 4.25942 16.5112 4.12942 16.7612C3.99942 17.0112 4.02942 17.3112 4.18942 17.5412C5.96942 19.9912 8.88942 21.4512 11.9994 21.4512C15.1094 21.4512 18.0294 19.9912 19.8094 17.5412C19.9794 17.3112 19.9994 17.0112 19.8694 16.7612C19.7394 16.5112 19.4794 16.3512 19.1994 16.3512Z"
        :fill="color"
      />
    </svg>
    <svg
      v-else
      :style="`width:${width}px;height:${width}px;fill:none;`"
      viewBox="0 0 25 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.36035 16.4912C4.70034 16.2414 5.17021 16.3212 5.41016 16.6611C6.91016 18.7211 9.37002 19.9512 12 19.9512C14.63 19.9512 17.0898 18.7211 18.5898 16.6611C18.8298 16.3312 19.2997 16.2514 19.6396 16.4912C19.9696 16.7312 20.0496 17.201 19.8096 17.541C18.0296 19.991 15.11 21.4512 12 21.4512C8.89004 21.4512 5.97044 19.991 4.19043 17.541C3.95043 17.211 4.02035 16.7412 4.36035 16.4912Z"
        :fill="color"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.9297 8.31152C13.2397 8.31152 14.2998 9.37164 14.2998 10.6816C14.2996 11.9914 13.3197 12.9608 12.0898 13.0508H10.4404V14.3213C10.4404 14.7512 10.09 15.1015 9.66016 15.1016C9.26016 15.1016 8.93988 14.8109 8.87988 14.4209V9.09082C8.88007 8.66098 9.23027 8.31152 9.66016 8.31152C9.69849 8.31153 9.73576 8.31612 9.77246 8.32129H11.9502L11.9297 8.31152ZM10.4404 11.4912H11.9404C12.3801 11.491 12.7497 11.1313 12.75 10.6816C12.75 10.2716 12.4498 9.93086 12.0498 9.88086H10.4404V11.4912Z"
        :fill="color"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.6299 8.31152C19.2099 8.31152 20.5 9.59164 20.5 11.1816V12.2207C20.5 12.9806 20.2 13.711 19.6602 14.251C19.1202 14.791 18.3899 15.0908 17.6299 15.0908H16.0596C15.6299 15.0906 15.2805 14.7412 15.2803 14.3115V9.09082C15.2805 8.66112 15.6299 8.31176 16.0596 8.31152H17.6299ZM16.8496 13.5215H17.6299C17.9797 13.5215 18.3098 13.3814 18.5498 13.1416C18.7898 12.9016 18.9297 12.5607 18.9297 12.2207V11.1816C18.9297 10.4616 18.3499 9.88086 17.6299 9.88086H16.8496V13.5215Z"
        :fill="color"
      />
      <path
        d="M7 8.31152C7.42988 8.31152 7.78008 8.66098 7.78027 9.09082C7.78027 9.52082 7.43 9.87109 7 9.87109H5.33008C5.19018 9.87109 5.07049 9.99099 5.07031 10.1309V13.2607C5.07031 13.4007 5.19008 13.5215 5.33008 13.5215H7C7.42987 13.5215 7.78006 13.871 7.78027 14.3008C7.78027 14.7308 7.43 15.0811 7 15.0811H5.33008C4.32008 15.0811 3.5 14.261 3.5 13.251V10.1211C3.50004 9.11113 4.3201 8.29102 5.33008 8.29102H7V8.31152Z"
        :fill="color"
      />
      <path
        d="M12 1.95117C15.11 1.95117 18.0296 3.41139 19.8096 5.86133C20.0496 6.19133 19.9796 6.66113 19.6396 6.91113C19.5097 7.01098 19.3501 7.05075 19.2002 7.05078C18.9702 7.05078 18.7398 6.94121 18.5898 6.74121C17.0898 4.68124 14.63 3.45117 12 3.45117C9.37002 3.45117 6.91016 4.68124 5.41016 6.74121C5.17021 7.07114 4.70033 7.15095 4.36035 6.91113C4.03035 6.67113 3.95043 6.20133 4.19043 5.86133C5.97044 3.41139 8.89004 1.95117 12 1.95117Z"
        :fill="color"
      />

    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default: '#E0E3E6' },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
